import { render, staticRenderFns } from "./veJkyOrganize.vue?vue&type=template&id=2dcb139e&scoped=true"
import script from "./veJkyOrganize.vue?vue&type=script&lang=js"
export * from "./veJkyOrganize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb139e",
  null
  
)

export default component.exports